import styled from 'styled-components'
import {P, accessTypographyThemeDefaults, accessTypographyTheme} from '@modifi/ui'
import {darkGray} from '@modifi/colors'

export const Anchor = styled.a`
  font-style: italic;
  color: ${({theme}): string => accessTypographyThemeDefaults(theme)?.color?.main};
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
    color: ${({theme}): string | undefined => accessTypographyTheme(theme)?.link?.color?.hover};
  }
`

export const StyledP = styled(P)`
  min-height: 1px;
`

export const StyledLi = styled.li`
  color: ${darkGray};
`
